<template>
  <header v-if="!unInterruptedView"
    class="is-fixed-top">
    <component :is="spinner"
      v-if="showSpinnerRequestCount > 0"
      :message="spinnerMessage" />
    <nav class="navbar"
      v-if="$userInfo">
      <div class="navbar-brand">
        <app-link class="navbar-item fq-logo py-0 pr-1"
          :url="rootUrl"
          @click.native="selectedMenuCode = ''">
          <img :src="logoImgPath"
            style="max-height: 1.875rem"
            alt=""
            width="185"
            height="30"
            title="Home">
        </app-link>
        <app-link class="navbar-item is-hidden-desktop tooltip is-tooltip-right"
          v-if="$userInfo.isSupportUser"
          :url="pollingLogUrl"
          title="Polling Logs"
          data-tooltip="Polling Logs">
          <span class="icon"
            style="color: #DC7633;">
            <i class="mdi mdi-file-document" />
          </span>
        </app-link>
        <app-link class="navbar-item is-hidden-desktop tooltip is-tooltip-right"
          v-if="$userInfo.isSupportUser"
          :url="errorLogUrl"
          title="View Errors"
          data-tooltip="View Errors">
          <span class="icon"
            style="color: #CD6155;">
            <i class="mdi mdi-alert" />
          </span>
        </app-link>
        <a class="navbar-item is-hidden-desktop tooltip is-tooltip-right"
          @click="signOut"
          title="Sign Out"
          data-tooltip="Sign Out">
          <span class="icon"
            style="color: #9B59B6;">
            <i class="mdi mdi-logout" />
          </span>
        </a>
        <div class="navbar-burger burger"
          data-target="main-nav-menu"
          @click="toogleBurgerMenu()">
          <span />
          <span />
          <span />
        </div>
      </div>
      <div id="main-nav-menu"
        class="navbar-menu"
        :class="{ 'is-active': burgerMenuActive}">
        <div class="navbar-start">
          <div class="navbar-item has-dropdown is-hoverable"
            v-for="i in finalNav"
            :key="i.name">
            <app-link class="navbar-link"
              :url="i.url">
              {{ i.name }}
            </app-link>
            <div class="navbar-dropdown is-boxed">
              <div v-for="(i2, idx2) in i.items"
                :key="i2.name">
                <hr v-if="i2.items.length > 0 && i.items[idx2-1] && i.items[idx2-1].items.length == 0"
                  class="navbar-divider">
                <div class="submenu-title"
                  v-if="i2.items.length > 0">
                  <span class="title is-6 has-text-primary">{{ i2.name }}</span>
                </div>
                <app-link v-if="i2.items.length == 0"
                  class="navbar-item"
                  :class="{ 'is-active': i2.code === selectedMenuCode }"
                  :url="i2.url">
                  {{ i2.name }}
                </app-link>
                <app-link v-else
                  v-for="i3 in i2.items"
                  :key="i3.name"
                  class="navbar-item"
                  :class="{ 'is-active': i3.code === selectedMenuCode }"
                  :url="i3.url">
                  {{ i3.name }}
                </app-link>
                <hr v-if="i2.items.length > 0"
                  class="navbar-divider">
              </div>
            </div>

          </div>

        </div>

        <div class="navbar-item"
          v-if="isGlobalSearchEnabled">
          <global-search :scoped-api-key="scopedSearchApiKey" />
        </div>

        <div class="navbar-end">
          <div class="navbar-item"
            v-if="$userInfo.isSystemAdministrator && !$userInfo.isSupportUser">
            <a :href="redirectToV1Url"
              target="_blank"> Redirect to V1</a>
          </div>
          <div class="navbar-item">
            <div class="dropdown is-hoverable theme-dropdown">
              <div class="dropdown-trigger">
                <button class="button is-info is-inverted">
                  <span class="msr msr-24px has-text-routine mr-2">
                    routine
                  </span>
                </button>
              </div>
              <div class="dropdown-menu">
                <div class="dropdown-content">
                  <a class="dropdown-item is-flex is-align-items-center"
                    :class="{ 'is-active': $theme.displayName === themes.light }"
                    @click="selectTheme(themes.light)">
                    <span class="msr msr-24px has-text-warning mr-2">
                      light_mode
                    </span>
                    <span class="is-capitalized">{{ themes.light }}</span>
                  </a>

                  <a class="dropdown-item is-flex is-align-items-center"
                    :class="{ 'is-active': $theme.displayName === themes.dark }"
                    @click="selectTheme(themes.dark)">
                    <span class="msr msr-24px has-text-primary mr-2">
                      dark_mode
                    </span>
                    <span class="is-capitalized">{{ themes.dark }}</span>
                  </a>

                  <a class="dropdown-item is-flex is-align-items-center"
                    :class="{ 'is-active': $theme.displayName === themes.system }"
                    @click="selectTheme(themes.system)">
                    <span class="msr msr-24px has-text-success mr-2">
                      desktop_windows
                    </span>
                    <span class="is-capitalized">{{ themes.system }}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="navbar-item py-0">
            <vue-clock />
          </div>
          <div class="navbar-item">
            <notification />
          </div>
          <div v-if="false"
            class="navbar-item">
            <agent />
          </div>
          <div class="navbar-item">
            <div class="field is-grouped">
              <!-- <notification /> -->
              <!-- <div class="control notification-message"
                @mouseleave="showNotification = false">
                <a class="button is-info"
                  :data-badge="notificationCount > 0 ? notificationCount : null"
                  :class="[{ 'has-badge-danger has-badge-rounded has-badge-small': notificationCount > 0 }]"
                  @click="toggleNotification($event)">
                  <span class="icon is-small">
                    <i class="mdi mdi-bell mdi-24px" />
                  </span>
                </a>
                <div v-if="showNotification"
                  class="notification-message-popup animated bounceIn"
                  style="animation-duration: 0.5s">
                  <article class="message is-danger">
                    <div class="message-header">
                      <p>Notifications</p>
                      <button class="delete"
                        @click="toggleNotification()" />
                    </div>
                    <div class="message-body">
                      <expiry-message :licence-data="licenceData" />
                    </div>
                  </article>
                </div>
              </div> -->
              <div class="dropdown is-right"
                :class="{ 'is-active': companyDropdownActive }"
                @mouseleave="companyDropdownActive = false">
                <div class="dropdown-trigger">
                  <a class="button company-nav-dropdown"
                    aria-haspopup="true"
                    aria-controls="dropdown-menu"
                    @click="toogleDropdown()">
                    <span>{{ $userInfo.companyName }}</span>
                    <span class="icon is-small">
                      <i class="mdi mdi-chevron-down mdi-18px" />
                    </span>
                  </a>
                </div>
                <!-- <transition mode="in-out" appear name="custom-classes-transition" appear-active-class="animated bounceIn" enter-active-class="animated bounceIn" leave-active-class="animated bounceInOut"> -->
                <!-- <div class="dropdown-menu animated bounceIn"
                  style="animation-duration: 0.5s"> -->
                <div class="dropdown-menu"
                  role="menu">
                  <div class="dropdown-content">
                    <div class="dropdown-item dropdown-item-has-icon">
                      <span class="icon"
                        style="color: #5D6D7E;">
                        <i class="mdi mdi-account mdi-18px" />
                      </span>
                      <span class="dropdown-item-text">{{ $userInfo.displayName }}</span>
                    </div>
                    <hr class="dropdown-divider">
                    <app-link class="dropdown-item dropdown-item-has-icon"
                      v-if="$userInfo.isSupportUser"
                      :url="pollingLogUrl"
                      @click.native="closeCompanyDropdown()">
                      <span class="icon"
                        style="color: #DC7633;">
                        <i class="mdi mdi-file-document mdi-18px" />
                      </span>
                      <span class="dropdown-item-text">Polling Log</span>
                    </app-link>
                    <app-link class="dropdown-item dropdown-item-has-icon"
                      v-if="$userInfo.isSupportUser"
                      :url="companyOnboardingUrl"
                      @click.native="closeCompanyDropdown()">
                      <span class="icon has-text-success">
                        <i class="mdi mdi-office-building-cog mdi-18px" />
                      </span>
                      <span class="dropdown-item-text">Company Onboarding</span>
                    </app-link>
                    <app-link class="dropdown-item dropdown-item-has-icon"
                      v-if="$userInfo.isSupportUser"
                      :url="errorLogUrl"
                      @click.native="closeCompanyDropdown()">
                      <span class="icon has-text-danger">
                        <i class="mdi mdi-alert mdi-18px" />
                      </span>
                      <span class="dropdown-item-text">View Error</span>
                    </app-link>
                    <a class="dropdown-item dropdown-item-has-icon"
                      href="#"
                      @click="signOut">
                      <span class="icon"
                        style="color: #9B59B6;">
                        <i class="mdi mdi-logout mdi-18px" />
                      </span>
                      <span class="dropdown-item-text">Sign Out</span>
                    </a>
                    <hr class="dropdown-divider">
                    <a class="dropdown-item dropdown-item-has-icon"
                      href="#"
                      @click="openAboutModal()">
                      <span class="icon has-text-primary">
                        <i class="mdi mdi-information-variant mdi-18px" />
                      </span>
                      <span class="dropdown-item-text">About</span>
                    </a>
                  </div>
                </div>
                <!-- </transition> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <about-modal :active.sync="isAboutModalActive"
      :expiry-date="expiryDate"
      @close="closeModal()" />
  </header>
</template>
<script>
import Auth from '@/auth'
import NavService from '@/components/NavService'
import { mapGetters, mapActions } from 'vuex'
import ExpiryMessage from '@/components/ExpiryMessage'
import { AboutModal } from '@/components/BulmaModal'
import { EventHubTypes } from '@/enums'
import UtilitiesRoutes from '@/views/utilities/route-types'
import VueClock from '@/components/VueClock/VueClock'
import Notification from '@/components/Notification/Notification'
import Agent from '@/components/Agent/Agent'
import ErrorLogRoutes from '@/views/errorlog/route-types'
import CompanyRoutes from './views/company/route-types'
import PollingLogRoutes from '@/views/pollinglog/route-types'
import GlobalSearch from '@/components/GobalSearch/GlobalSearch.vue'
import { Themes } from '@/enums'
import Spinner from '@/components/Spinners'
import SuperadminUserRoutes from './views/superadmin/user/route-types'
import SuperadminCountrySettingRoutes from './views/superadmin/countrysetting/route-types'
import SuperadminSystemModuleRoutes from '@/views/superadmin/systemmodule/route-types'
import SuperadminFlexiquoteModuleRoutes from '@/views/superadmin/flexiquotemodule/route-types'
import SuperadminCompanyRoutes from './views/superadmin/company/route-types'
import SuperadminVehicleLookupRoutes from './views/superadmin/vehiclelookup/route-types'
import SuperadminSystemMessageRoutes from '@/views/superadmin/systemmessage/route-types'

export default {
  components: {
    ExpiryMessage,
    AboutModal,
    VueClock,
    Notification,
    Agent,
    GlobalSearch
  },
  data() {
    return {
      auth: this.$store.state.auth,
      nav: null,
      isLoading: true,
      isLoadingClass: 'is-loading',
      notificationCount: 0,
      showNotification: false,
      licenceData: null,
      burgerMenuActive: false,
      companyDropdownActive: false,
      selectedMenuCode: '',
      isAboutModalActive: false,
      unInterruptedView: false
    }
  },
  computed: {
    rootUrl: function () {
      return '/'
    },
    pnetUrl: function () {
      return {
        path: UtilitiesRoutes.PnetUtilitiesDetail.path,
        params: {}
      }
    },
    ormUrl: function () {
      return {
        path: UtilitiesRoutes.OrmUtilitiesDetail.path,
        params: {}
      }
    },
    pollingLogUrl: function () {
      return PollingLogRoutes.PollingLogListView.path
    },
    // pollingLogUrl: function () {
    //   return process.env.VUE_APP_ROOT_URI + '/Modules/EstimatesView/PollingLog.aspx'
    // },
    viewErrorUrl: function () {
      return process.env.VUE_APP_ROOT_URI + '/Error/ErrorDetailView.aspx'
    },
    companyOnboardingUrl() {
      return CompanyRoutes.CompanyOnboardingView.path
    },
    errorLogUrl() {
      return ErrorLogRoutes.ErrorLogListView.path
    },
    buttonCSS: function () {
      return `${this.isLoadingClass}`
    },
    expiryDate: function () {
      if (this.licenceData) {
        const localDate = new Date(this.licenceData.expiryDate)
        if (Intl) {
          return Intl.DateTimeFormat(this.$userInfo.locale).format(localDate)
        } else {
          return localDate.toLocaleDateString(this.$userInfo.locale)
        }
      } else {
        return ''
      }
    },
    ...mapGetters(['licenceExpired', 'showSpinnerRequestCount', 'spinnerMessage']),
    spinner() {
      return Spinner
    },
    companyId() {
      return this.$company ? this.$company.setting.companyId : null
    },
    scopedSearchApiKey() {
      return this.$company && this.$company.setting ? this.$company.setting.typesenseApiKey : null
    },
    // Show the search bar whenever the company has a scoped key. Gating on a
    // live startup test search used to hide the bar for the whole session on a
    // single transient/expired failure; the GlobalSearch component now handles
    // search failures (and key refresh) itself.
    isGlobalSearchEnabled() {
      return !!this.scopedSearchApiKey
    },
    themes() {
      return Themes
    },
    logoImgPath() {
      return this.$theme.isDark ? require('@/assets/images/flexiquote-logo-dark.svg') : require('@/assets/images/flexiquote-logo-light.svg')
    },
    finalNav() {
      var finalNav = []
      if (this.$userInfo.isSystemAdministrator && !this.$userInfo.isSupportUser) {
        finalNav = [
          {
            name: 'Admin',
            items: [
              {
                name: 'Company',
                url: SuperadminCompanyRoutes.CompanyListView.path,
                items: []
              },
              {
                name: 'Users',
                url: SuperadminUserRoutes.UserListView.path,
                items: []
              },
              {
                name: 'Country Setup',
                url: SuperadminCountrySettingRoutes.CountrySettingListView.path,
                items: []
              },
              {
                name: 'Modules',
                url: SuperadminFlexiquoteModuleRoutes.FlexiquoteModuleListView.path,
                items: []
              },
              {
                name: 'Modules Enable/Disable',
                url: SuperadminSystemModuleRoutes.SystemModuleView.path,
                items: []
              },
              {
                name: 'Vehicle Lookup Pricing',
                url: SuperadminVehicleLookupRoutes.VehicleLookupView.path,
                items: []
              },
              {
                name: 'System Message',
                url: SuperadminSystemMessageRoutes.SystemMessageView.path,
                items: []
              }
            ]
          }
        ]
      } else {
        finalNav = this.nav
      }
      return finalNav
    },
    redirectToV1Url: function () {
      return process.env.VUE_APP_ROOT_URI + '/admin/company/list'
    }
  },
  watch: {
    $route: function () {
      this.changeTitle()

      if (!!this.$route.query.uninterruptedview) {
        this.unInterruptedView = true
      }
    },

    '$theme.name': function (newVal) {
      document.documentElement.className = `theme-${newVal}`
    }
  },
  created() {
    this.$eventHub.$on(EventHubTypes.SetActiveMenuCode, (code) => {
      this.selectedMenuCode = code
    })
  },
  mounted: async function () {
    this.$showSpinner()
    // try {
    // Nav bar
    const nav = await NavService.getNav()
    this.nav = nav

    const licenceResult = await NavService.getLicenceData()

    // Global user data
    this.licenceData = licenceResult
    this.isLoadingClass = 'is-inverted'

    // Licence data
    if (this.licenceData.isExpired || this.licenceData.isExpiring) {
      this.notificationCount++
      this.updateLicenceExpired(this.licenceData.isExpired && !this.licenceData.isGracePeriod)
    } else {
      if (this.notificationCount > 0) {
        this.notificationCount--
      } else {
        this.notificationCount = 0
      }
      this.updateLicenceExpired(false)
    }
    // } catch (err) {
    //   // temp solution
    //   // either one of the promises failure will cause spinner to spin infinitely
    //   // trying to show fatal errors with another dialogue
    //   console.log(err)
    // }

    this.$hideSpinner()
    this.changeTitle()

    //Listen for system theme changes
    this.addSystemThemeListener()
  },
  beforeDestroy() {
    window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', this.handleSystemThemeChange)
  },
  methods: {
    addSystemThemeListener() {
      window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', this.handleSystemThemeChange)
    },
    toogleBurgerMenu() {
      this.burgerMenuActive = !this.burgerMenuActive
    },
    logout() {
      Auth.logout()
    },
    toggleNotification(event) {
      if (this.notificationCount > 0) {
        this.showNotification = !this.showNotification
      }
    },
    removeAllSessionObjects() {
      Object.keys(sessionStorage)
        // .filter(function(k) { return /foo/.test(k) })
        .forEach(function (k) {
          sessionStorage.removeItem(k)
        })
    },
    signOut() {
      this.$showSpinner()
      this.companyDropdownActive = false
      NavService.signOut()
        .then((result) => {
          if (result.data) {
            // this.removeAllSessionObjects()
            window.location.href = process.env.VUE_APP_ROOT_URI + (this.$userInfo.isSupportUser ? '/SignInCsr.aspx' : '/SignIn.aspx')
          }
        })
        .catch(function (error) {
          this.$hideSpinner()
          console.error(error)
        })
    },
    toogleDropdown() {
      this.companyDropdownActive = !this.companyDropdownActive
    },
    openAboutModal() {
      this.companyDropdownActive = false
      this.isAboutModalActive = true
    },
    closeModal() {
      this.isAboutModalActive = false
    },
    ...mapActions(['updateLicenceExpired']),
    closeCompanyDropdown() {
      this.companyDropdownActive = false
      this.selectedMenuCode = ''
    },
    changeTitle() {
      const routes = this.$route.matched.slice()
      var title = ''
      routes.forEach((r, idx) => {
        if (idx > 0) {
          title += ' '
        }
        title += r.meta.title
      })
      document.title = title // parentRoute.meta.title
    },
    handleSystemThemeChange() {
      this.toggleTheme(this.themes.system)
    },
    selectTheme(theme) {
      this.toggleTheme(theme)
    }
  }
}
</script>
<style lang="scss" scoped>
.submenu-title {
  padding: 0.2rem 0.5rem; // > span {
  //   font-size: 1rem;
  //   font-weight: 600;
  // }
}

.navbar {
  z-index: 32;
}

.notification-message {
  position: relative !important;
  display: inline-block !important;
}

.notification-message-popup {
  right: 0;
  display: block;
  position: absolute;
  min-width: 480px;
  z-index: 1000;
}
div.dropdown-item-has-icon {
  display: flex;
  align-items: center;
}
a.dropdown-item-has-icon {
  display: flex;
  align-items: center;
}
span.dropdown-item-text {
  padding-left: 5px;
}

.theme-dropdown .dropdown-menu {
  min-width: 10em;
  width: 10em;
  max-width: 12em;
}

.company-nav-dropdown {
  border: none !important;
  box-shadow: none;
  padding: 0;
  &:hover {
    background-color: transparent !important;
  }
}

.fq-logo {
  background-color: transparent !important;
}
</style>
